import { ApiError, ErrorType } from '../models/ApiError';
import { defaultErrorHandler } from '../services/ErrorHandler';

/**
 * Utility class for handling error types and getting user-friendly messages
 */
export class ErrorTypeHandler {
  /**
   * Get user-friendly error message from ApiError
   */
  static getUserFriendlyMessage(error: ApiError): string {
    return defaultErrorHandler.getUserFriendlyMessage(error);
  }

  /**
   * Check if error should trigger logout
   */
  static shouldLogout(error: ApiError): boolean {
    return defaultErrorHandler.shouldLogout(error);
  }

  /**
   * Check if error should be retried
   */
  static shouldRetry(error: ApiError): boolean {
    return defaultErrorHandler.shouldRetry(error);
  }
}

